module.exports = __webpack_public_path__ + "static/media/carpoolBackground.dea2f014.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Carpool/carpoolBackground.svg
// module id = 931
// module chunks = 0